<template>
    <Breadcrumb class="app-levelbar">
        <Icon type="home" class="app-home"></Icon>
        <BreadcrumbItem v-for="(item,index) in levelList" :href="item.path" :key="index">
            <router-link v-if="index == levelList.length-1" to="" class="no-redirect">{{item.meta.title}}</router-link>
            <router-link v-else :to="item.path">{{item.meta.title}}</router-link>
        </BreadcrumbItem>
    </Breadcrumb>
</template>
 
<script type="text/ecmascript-6">
export default {
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null
    };
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta.title && !item.meta.noBreadCrumb);
      const first = matched[0];
      if(matched[1]&&matched[1].meta.parentPath){
        matched.splice(1,0,{path:matched[1].meta.parentPath,meta:{title:matched[1].meta.parentTitle}})
      }
      if (first && first.meta.title !== "首页") {
        matched = [{ path: "/", meta:{title:'首页'}}].concat(matched);
      }
      this.levelList = matched;
    },
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb();
    }
  }
}
</script>
 
<style lang="css" scoped>
.app-levelbar{
    font-size: 12px;
    color:  #495060;
}
.app-home{
  opacity: 0.21;
  font-size: 16px;
  vertical-align: -1px;
}
.app-levelbar .no-redirect{
	color: #A4A7AF;;
  cursor: text;
}
</style>